const DATE_CONSTANTS = {
  renderFormat: 'MMM D',
  parseFormat: 'DDMMYYYY',
  renderApiFormat: 'YYYY-MM-DD',
  renderApiDateFormat: 'yyyy-MM-dd',
  datePipeRenderFormat: 'MMM dd, yyyy'
};

export default DATE_CONSTANTS;
export const MAX_AGE = 130;
export const MIN_AGE = 18;
